import update from "immutability-helper";
import _ from "lodash";
import client from "lib/apolloClient/client";

import { shareCourseFlowResourceMutation } from "CourseFlow/modules/CourseFlowMutations";
import {
  createTimetableSlotResourceMutation,
  importTimetableSlotResourceMutation,
  updateTimetableSlotItemsMutation,
  updateTimetableSlotResourceMutation,
  moveTimetableSlotContentMutation,
  duplicateTimetableSlotContentMutation,
  reorderTimetableSlotContentMutation,
  clearTimetableSlotContentMutation,
  getTimetablePlannerDownloadUrlMutation,
} from "./TimetablePlannerMutations";
import {
  getClassTimetablePeriodsQuery,
  getTeacherTimetablePeriodsQuery,
} from "./TimetablePlannerQueries";
import { TEACHER } from "Constants/stringConstants";
import {
  getSelectedLearningCourse,
  getSelectedLearningCourseId,
} from "LearningCourse/modules/LearningCourseUtils";
import {
  getSelectedAcademicYearId,
  getSelectedCurriculumId,
} from "modules/CommonSelectors";
import {
  getClassTimetablePlannerVariables,
  getTeacherTimetableVariables,
} from "./utils";
import { getAddNewItemToTopPreference } from "Utils/EntityFlowUtils";
import { dispatchError, getRelativePath, isUserTypeStaff } from "Utils";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { ITEM_TYPES, TOAST_ACTION_LABELS } from "CourseFlow/modules/Utils";
import { openLinkInNewTab } from "modules/Services";
import { getIsLearningCoursesEnabled } from "LearningCourses/modules/Utils";
import { getUserInfo } from "Login/modules/LoginModule";
import { goToLearningCourseChildRoute } from "modules/NavigationModule";

export const NAME = "timetablePlanner";
export const SET_IS_LOADER_VISIBLE = "SET_IS_LOADER_VISIBLE" + " " + NAME;
export const UPDATE_DATE_RANGE = "UPDATE_DATE_RANGE" + " " + NAME;
export const UPDATE_FILTERS = "UPDATE_FILTERS" + " " + NAME;
export const UPDATE_DISPLAY_SETTINGS = "UPDATE_DISPLAY_SETTINGS" + " " + NAME;
export const SET_ADD_NOTE_MODAL_DATA = "SET_ADD_NOTE_MODAL_DATA" + " " + NAME;
export const SET_ADD_LINK_MODAL_DATA = "SET_ADD_LINK_MODAL_DATA" + " " + NAME;
export const SET_COURSE_FLOW_MODAL_DATA =
  "SET_COURSE_FLOW_MODAL_DATA" + " " + NAME;
export const SET_CLASS_ASSIGNMENT_MODAL_DATA =
  "SET_CLASS_ASSIGNMENT_MODAL_DATA" + " " + NAME;
export const SET_ASSESSMENT_IMPORT_MODAL_DATA =
  "SET_ASSESSMENT_IMPORT_MODAL_DATA" + " " + NAME;
export const SET_ACTIVE_SLOT_ID = "SET_ACTIVE_SLOT_ID" + " " + NAME;
export const SET_SELECT_ITEM_SLOT_MODAL =
  "SET_SELECT_ITEM_SLOT_MODAL" + " " + NAME;

export const SET_WORKSHEET_MODAL_DATA = "SET_WORKSHEET_MODAL_DATA" + " " + NAME;
export const SET_CHANGE_TASK_TYPE_MODAL_DATA =
  "SET_CHANGE_TASK_TYPE_MODAL_DATA" + " " + NAME;
export const SET_SHARE_CONTENT_MODAL_DATA =
  "SET_SHARE_CONTENT_MODAL_DATA" + " " + NAME;
export const SET_ASSESSMENT_MODAL_DATA =
  "SET_ASSESSMENT_MODAL_DATA" + " " + NAME;

export const RESET_REDUX_STATE = "RESET_REDUX_STATE" + " " + NAME;

export const getActionToast = ({ action, customLabel, itemType, name }) => {
  let customMsg, label;

  switch (itemType) {
    case ITEM_TYPES.LINK: {
      label = "common:link";

      break;
    }

    case ITEM_TYPES.NOTE: {
      label = "common:note";

      break;
    }

    case ITEM_TYPES.FILE: {
      label = "common:resource_label";

      break;
    }

    case ITEM_TYPES.ITEM: {
      label = "common:item";

      break;
    }

    case ITEM_TYPES.ITEMS: {
      label = "common:items";

      break;
    }

    case ITEM_TYPES.LE: {
      if (action == TOAST_ACTION_LABELS.REMOVED) {
        customMsg = "common:label_removed_from_course_flow";
        label = "common:learning_experience_abbreviation";
      } else if (action == TOAST_ACTION_LABELS.ASSIGNED) {
        customMsg = "common:copy_of_label_assigned_to_course";
        label = "common:learning_experience_abbreviation";
      } else label = "common:task_label";

      break;
    }

    case ITEM_TYPES.ASSESSMENT: {
      if (action == TOAST_ACTION_LABELS.ASSIGNED) {
        customMsg = "common:copy_of_label_assigned_to_course";
        label = name;
      } else label = "common:assessment_label";

      break;
    }
  }

  return setToastMsg({
    msg: customMsg || "toastMsgs:action_successfully",
    locale_params: [
      {
        key: "label",
        value: customLabel || label,
        isPlainText: false,
      },
      {
        key: "action",
        value: action,
        isPlainText: false,
      },
      {
        key: "name",
        value: name,
        isPlainText: false,
      },
    ],
    type: "success",
  });
};

// Actions
export const updateDateRange = data => {
  return { type: UPDATE_DATE_RANGE, data };
};

export const updateFilters = data => {
  return {
    type: UPDATE_FILTERS,
    data,
  };
};

export const setIsLoaderVisible = data => {
  return { type: SET_IS_LOADER_VISIBLE, data };
};

export const updateDisplaySettings = data => {
  return { type: UPDATE_DISPLAY_SETTINGS, data };
};

export const setAddNoteModalData = data => {
  return { type: SET_ADD_NOTE_MODAL_DATA, data };
};

export const setAddLinkModalData = data => {
  return { type: SET_ADD_LINK_MODAL_DATA, data };
};

export const setCourseFlowModalData = data => {
  return { type: SET_COURSE_FLOW_MODAL_DATA, data };
};

export const setClassAssignmentModalData = data => {
  return { type: SET_CLASS_ASSIGNMENT_MODAL_DATA, data };
};

export const setAssessmentImportModalData = data => {
  return { type: SET_ASSESSMENT_IMPORT_MODAL_DATA, data };
};
export const setWorksheetModalData = data => {
  return { type: SET_WORKSHEET_MODAL_DATA, data };
};

export const setChangeTaskTypeModalData = data => {
  return { type: SET_CHANGE_TASK_TYPE_MODAL_DATA, data };
};

export const setActiveSlot = data => {
  return { type: SET_ACTIVE_SLOT_ID, data };
};

export const setShareContentModalData = data => {
  return { type: SET_SHARE_CONTENT_MODAL_DATA, data };
};

export const setAssignmentModalData = data => {
  return { type: SET_ASSESSMENT_MODAL_DATA, data };
};

export const setSelectSlotItemModalData = data => {
  return { type: SET_SELECT_ITEM_SLOT_MODAL, data };
};

export const resetReduxState = () => {
  return { type: RESET_REDUX_STATE };
};

/**
 * Navigates to class route based on learning course availability
 * @param {Object} params - Parameters for navigation
 * @param {string} params.classId - ID of the class to navigate to
 * @param {boolean} params.isOpenInNewTab - Whether to open in new tab
 */
export const goToClassRoute = ({
  classId,
  isOpenInNewTab = true,
  learningCourseId,
  curriculumProgramId,
  route,
}) => {
  return dispatch => {
    const userInfo = getUserInfo();
    const userType = userInfo.user_type;
    const isUserTeacher = isUserTypeStaff({ userType });

    const isLearningCoursesEnabled =
      !!learningCourseId ||
      getIsLearningCoursesEnabled({
        curriculumProgramId: curriculumProgramId,
      });

    let redirectUrl;

    if (isLearningCoursesEnabled && isUserTeacher) {
      dispatch(
        goToLearningCourseChildRoute({
          learningCourseId,
          curriculumProgramId: curriculumProgramId,
          isOpenInNewTab,
          route,
          classId,
        })
      );
      return;
    } else {
      if (route) {
        redirectUrl = `/platform/${curriculumProgramId}/courses/${classId}/${route}`;
      } else {
        redirectUrl = `/platform/${curriculumProgramId}/courses/${classId}`;
      }
    }

    if (isOpenInNewTab) {
      dispatch(
        openLinkInNewTab({
          url: getRelativePath(redirectUrl),
        })
      );
    }
  };
};
/**
 * Creates a resource for a timetable slot
 * @param {Object} params - Parameters for creating resource
 * @param {Object} params.resources - resources data to create
 * @param {string} params.timetableSlotId - ID of the timetable slot
 * @param {string} params.timetableType - Type of timetable (TEACHER or CLASS)
 * @param {string} params.selectedStaffId - ID of the selected staff (if applicable)
 * @param {boolean} params.showToast - Whether to show toast message
 */
export const createTimetableSlotResource = ({
  resources,
  timetableSlotId,
  timetableType,
  selectedStaffId,
  learningCourseId,
  showToast = true,
}) => {
  return async (dispatch, getState) => {
    const state = getState();

    const dateRange = _.get(state, "timetablePlanner.dateRange", []);
    const learningCourse = getSelectedLearningCourse(state);

    const academicYearId = getSelectedAcademicYearId(state);
    const curriculumProgramId = getSelectedCurriculumId(state);
    const weekStartDate = _.first(dateRange);
    const weekEndDate = _.last(dateRange);

    const allClassIds = _.get(learningCourse, "classes", []);

    const filters = _.get(state, "timetablePlanner.filters", {});
    const classFilters = _.get(filters, "classes", []);

    const classIds =
      _.isEmpty(classFilters) || classFilters === "ALL"
        ? allClassIds
        : classFilters;

    // Query variables
    const {
      variables: classTimetableVariables,
    } = getClassTimetablePlannerVariables({
      classIds,
      timetableType,
      academicYearId,
      weekStartDate,
      weekEndDate,
      curriculumProgramId,
      dateRange,
    });

    const {
      variables: teacherTimetableVariables,
    } = getTeacherTimetableVariables({
      weekStartDate,
      weekEndDate,
      academicYearId,
      dateRange,
      selectedStaffId,
      timetableType,
    });

    const addToTop = getAddNewItemToTopPreference();

    dispatch(setIsLoaderVisible(true));

    try {
      // Prepare input for mutation
      const input = {
        learningCourseId:
          learningCourseId || getSelectedLearningCourseId(state),
        resources,
        addToTop: _.isBoolean(addToTop) ? addToTop : false,
        entityMapping: {
          entityId: timetableSlotId,
          entityType: "TIMETABLE_SLOT",
        },
      };

      // Determine which query to refetch based on timetable type
      const refetchQuery =
        timetableType === TEACHER
          ? getTeacherTimetablePeriodsQuery
          : getClassTimetablePeriodsQuery;

      // Determine which refetch variables to use based on timetable type
      const refetchVariables =
        timetableType === TEACHER
          ? teacherTimetableVariables
          : classTimetableVariables;

      // Execute mutation with refetch and return response
      const response = await client.mutate({
        mutation: createTimetableSlotResourceMutation,
        variables: { input },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: refetchQuery,
            variables: refetchVariables,
          },
        ],
      });

      const originalItemType = _.first(resources)?.itemType;

      let itemType;
      if (originalItemType == "FILE") {
        const attachmentType = _.get(
          _.first(resources),
          "itemInput.attachment.type",
          ""
        );

        if (_.includes([ITEM_TYPES.NOTE, ITEM_TYPES.LINK], attachmentType))
          itemType = attachmentType;
        else itemType = ITEM_TYPES.FILE;
      } else if (originalItemType == "ASSESSMENT") {
        const assessmentType = _.get(
          _.first(resources),
          "itemInput.assessment.type",
          ""
        );

        if (assessmentType == "LEARNING_ENGAGEMENT") itemType = ITEM_TYPES.LE;
        else itemType = ITEM_TYPES.ASSESSMENT;
      } else itemType = ITEM_TYPES.ITEM;

      if (showToast) {
        dispatch(
          getActionToast({
            action: TOAST_ACTION_LABELS.CREATED,
            itemType,
          })
        );
      }

      return response;
    } catch (error) {
      console.error("Error creating timetable slot resource:", error);
    } finally {
      dispatch(setIsLoaderVisible(false));
    }
  };
};

/**
 * Import a resource for a timetable slot
 * @param {Object} params - Parameters for creating resource
 * @param {Object} params.resources - resources data to create
 * @param {string} params.timetableSlotId - ID of the timetable slot
 * @param {string} params.timetableType - Type of timetable (TEACHER or CLASS)
 * @param {string} params.selectedStaffId - ID of the selected staff (if applicable)
 * @param {boolean} params.showToast - Whether to show toast message
 */
export const importTimetableSlotResource = ({
  timetableSlotId,
  timetableType,
  selectedStaffId,
  sourceId,
  destinationId,
  includedIds,
  showToast = true,
}) => {
  return async (dispatch, getState) => {
    const state = getState();

    const dateRange = _.get(state, "timetablePlanner.dateRange", []);

    const learningCourse = getSelectedLearningCourse(state);

    const academicYearId = getSelectedAcademicYearId(state);
    const curriculumProgramId = getSelectedCurriculumId(state);
    const weekStartDate = _.first(dateRange);
    const weekEndDate = _.last(dateRange);

    const allClassIds = _.get(learningCourse, "classes", []);

    const filters = _.get(state, "timetablePlanner.filters", {});
    const classFilters = _.get(filters, "classes", []);

    const classIds =
      _.isEmpty(classFilters) || classFilters === "ALL"
        ? allClassIds
        : classFilters;

    // Query variables
    const {
      variables: classTimetableVariables,
    } = getClassTimetablePlannerVariables({
      classIds,
      timetableType,
      academicYearId,
      weekStartDate,
      weekEndDate,
      curriculumProgramId,
      dateRange,
    });

    const {
      variables: teacherTimetableVariables,
    } = getTeacherTimetableVariables({
      weekStartDate,
      weekEndDate,
      academicYearId,
      dateRange,
      selectedStaffId,
      timetableType,
    });

    const addToTop = getAddNewItemToTopPreference();

    dispatch(setIsLoaderVisible(true));

    try {
      // Prepare input for mutation
      const input = {
        sourceId,
        destinationId,
        includedIds,
        curriculumProgramId,
        addToTop: _.isBoolean(addToTop) ? addToTop : false,
        entityMapping: {
          entityId: timetableSlotId,
          entityType: "TIMETABLE_SLOT",
        },
      };

      // Determine which query to refetch based on timetable type
      const refetchQuery =
        timetableType === TEACHER
          ? getTeacherTimetablePeriodsQuery
          : getClassTimetablePeriodsQuery;

      // Determine which refetch variables to use based on timetable type
      const refetchVariables =
        timetableType === TEACHER
          ? teacherTimetableVariables
          : classTimetableVariables;

      // Execute mutation with refetch
      await client.mutate({
        mutation: importTimetableSlotResourceMutation,
        variables: { input },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: refetchQuery,
            variables: refetchVariables,
          },
        ],
      });

      if (showToast) {
        dispatch(
          getActionToast({
            action: TOAST_ACTION_LABELS.IMPORTED,
            itemType:
              _.size(includedIds) > 1 ? ITEM_TYPES.ITEMS : ITEM_TYPES.ITEM,
          })
        );
      }
    } catch (error) {
      console.error("Error creating timetable slot resource:", error);
    } finally {
      dispatch(setIsLoaderVisible(false));
    }
  };
};

/**
 * Updates items (add/remove) for a timetable slot
 * @param {Object} params - Parameters for updating items
 * @param {Object} params.items - Items object with added/removed arrays { added: [...], removed: [...] }
 * @param {string} params.timetableSlotId - ID of the timetable slot
 * @param {string} params.timetableType - Type of timetable (TEACHER or CLASS)
 * @param {string} params.selectedStaffId - ID of the selected staff (if applicable)
 */
export const updateTimetableSlotItems = ({
  items,
  timetableSlotId,
  timetableType,
  selectedStaffId,
  showToast = true,
}) => {
  return async (dispatch, getState) => {
    const state = getState();

    const dateRange = _.get(state, "timetablePlanner.dateRange", []);
    const learningCourse = getSelectedLearningCourse(state);
    const academicYearId = getSelectedAcademicYearId(state);
    const curriculumProgramId = getSelectedCurriculumId(state);
    const weekStartDate = _.first(dateRange);
    const weekEndDate = _.last(dateRange);

    const allClassIds = _.get(learningCourse, "classes", []);
    const filters = _.get(state, "timetablePlanner.filters", {});
    const classFilters = _.get(filters, "classes", []);

    const classIds =
      _.isEmpty(classFilters) || classFilters === "ALL"
        ? allClassIds
        : classFilters;

    // Query variables
    const {
      variables: classTimetableVariables,
    } = getClassTimetablePlannerVariables({
      classIds,
      timetableType,
      academicYearId,
      weekStartDate,
      weekEndDate,
      curriculumProgramId,
      dateRange,
    });

    const {
      variables: teacherTimetableVariables,
    } = getTeacherTimetableVariables({
      weekStartDate,
      weekEndDate,
      academicYearId,
      dateRange,
      selectedStaffId,
      timetableType,
    });

    dispatch(setIsLoaderVisible(true));

    try {
      // Prepare input for mutation
      const input = {
        id: timetableSlotId,
        items,
        academicYearId,
      };

      // Determine which query to refetch based on timetable type
      const refetchQuery =
        timetableType === TEACHER
          ? getTeacherTimetablePeriodsQuery
          : getClassTimetablePeriodsQuery;

      // Determine which refetch variables to use based on timetable type
      const refetchVariables =
        timetableType === TEACHER
          ? teacherTimetableVariables
          : classTimetableVariables;

      // Execute mutation with refetch
      await client.mutate({
        mutation: updateTimetableSlotItemsMutation,
        variables: { input },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: refetchQuery,
            variables: refetchVariables,
          },
        ],
      });

      const addedItems = _.get(items, "added", []);
      const removedItems = _.get(items, "removed", []);

      const action = !_.isEmpty(addedItems)
        ? TOAST_ACTION_LABELS.ADDED
        : TOAST_ACTION_LABELS.REMOVED;

      const allItems =
        action === TOAST_ACTION_LABELS.ADDED ? addedItems : removedItems;

      const itemType =
        _.size(allItems) > 1 ? ITEM_TYPES.ITEMS : ITEM_TYPES.ITEM;

      if (showToast) {
        dispatch(
          getActionToast({
            action,
            itemType,
          })
        );
      }
    } catch (error) {
      console.error("Error adding timetable slot items:", error);
    } finally {
      dispatch(setIsLoaderVisible(false));
    }
  };
};

export const updateTimetableSlotResource = ({
  input,
  timetableType,
  selectedStaffId,
  showToast = true,
}) => {
  return async (dispatch, getState) => {
    const state = getState();

    const dateRange = _.get(state, "timetablePlanner.dateRange", []);
    const learningCourse = getSelectedLearningCourse(state);
    const academicYearId = getSelectedAcademicYearId(state);
    const curriculumProgramId = getSelectedCurriculumId(state);
    const weekStartDate = _.first(dateRange);
    const weekEndDate = _.last(dateRange);

    const allClassIds = _.get(learningCourse, "classes", []);
    const filters = _.get(state, "timetablePlanner.filters", {});
    const classFilters = _.get(filters, "classes", []);

    const classIds =
      _.isEmpty(classFilters) || classFilters === "ALL"
        ? allClassIds
        : classFilters;

    // Query variables
    const {
      variables: classTimetableVariables,
    } = getClassTimetablePlannerVariables({
      classIds,
      timetableType,
      academicYearId,
      weekStartDate,
      weekEndDate,
      curriculumProgramId,
      dateRange,
    });

    const {
      variables: teacherTimetableVariables,
    } = getTeacherTimetableVariables({
      weekStartDate,
      weekEndDate,
      academicYearId,
      dateRange,
      selectedStaffId,
      timetableType,
    });

    dispatch(setIsLoaderVisible(true));

    try {
      // Determine which query to refetch based on timetable type
      const refetchQuery =
        timetableType === TEACHER
          ? getTeacherTimetablePeriodsQuery
          : getClassTimetablePeriodsQuery;

      // Determine which refetch variables to use based on timetable type
      const refetchVariables =
        timetableType === TEACHER
          ? teacherTimetableVariables
          : classTimetableVariables;

      // Execute mutation with refetch
      await client.mutate({
        mutation: updateTimetableSlotResourceMutation,
        variables: { input },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: refetchQuery,
            variables: refetchVariables,
          },
        ],
      });

      const itemType = _.get(input, "attachment.type");

      if (showToast) {
        dispatch(
          getActionToast({
            action: TOAST_ACTION_LABELS.UPDATED,
            itemType,
          })
        );
      }
    } catch (error) {
      console.error("Error adding timetable slot items:", error);
    } finally {
      dispatch(setIsLoaderVisible(false));
    }
  };
};

export const shareResource = ({
  id,
  action,
  sharingState,
  addedClasses = [],
  deletedClasses = [],
  updatedClasses = [],
  learningCourseId,
  timetableType,
  selectedStaffId,
}) => {
  return async (dispatch, getState) => {
    const state = getState();

    const dateRange = _.get(state, "timetablePlanner.dateRange", []);
    const learningCourse = getSelectedLearningCourse(state);
    const academicYearId = getSelectedAcademicYearId(state);
    const curriculumProgramId = getSelectedCurriculumId(state);
    const weekStartDate = _.first(dateRange);
    const weekEndDate = _.last(dateRange);

    const allClassIds = _.get(learningCourse, "classes", []);
    const filters = _.get(state, "timetablePlanner.filters", {});
    const classFilters = _.get(filters, "classes", []);

    const classIds =
      _.isEmpty(classFilters) || classFilters === "ALL"
        ? allClassIds
        : classFilters;

    // Query variables
    const {
      variables: classTimetableVariables,
    } = getClassTimetablePlannerVariables({
      classIds,
      timetableType,
      academicYearId,
      weekStartDate,
      weekEndDate,
      curriculumProgramId,
      dateRange,
    });

    const {
      variables: teacherTimetableVariables,
    } = getTeacherTimetableVariables({
      weekStartDate,
      weekEndDate,
      academicYearId,
      dateRange,
      selectedStaffId,
      timetableType,
    });

    dispatch(setIsLoaderVisible(true));

    try {
      // Prepare variable for mutation
      const variables = {
        input: {
          id,
          learningCourseId,
          action,
          addedClasses,
          deletedClasses,
          updatedClasses,
          state: sharingState,
        },
      };

      // Determine which query to refetch based on timetable type
      const refetchQuery =
        timetableType === TEACHER
          ? getTeacherTimetablePeriodsQuery
          : getClassTimetablePeriodsQuery;

      // Determine which refetch variables to use based on timetable type
      const refetchVariables =
        timetableType === TEACHER
          ? teacherTimetableVariables
          : classTimetableVariables;

      // Execute mutation with refetch
      await client.mutate({
        mutation: shareCourseFlowResourceMutation,
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: refetchQuery,
            variables: refetchVariables,
          },
        ],
      });
    } catch (error) {
      console.error(error);
      dispatchError({ dispatch, e: error });
    } finally {
      dispatch(setIsLoaderVisible(false));
    }
  };
};

export const moveTimetableSlotContent = ({
  input,
  itemId,
  timetableType,
  selectedStaffId,
  showToast = true,
}) => {
  return async (dispatch, getState) => {
    const state = getState();

    const dateRange = _.get(state, "timetablePlanner.dateRange", []);
    const learningCourse = getSelectedLearningCourse(state);
    const academicYearId = getSelectedAcademicYearId(state);
    const curriculumProgramId = getSelectedCurriculumId(state);
    const weekStartDate = _.first(dateRange);
    const weekEndDate = _.last(dateRange);

    const allClassIds = _.get(learningCourse, "classes", []);
    const filters = _.get(state, "timetablePlanner.filters", {});
    const classFilters = _.get(filters, "classes", []);

    const classIds =
      _.isEmpty(classFilters) || classFilters === "ALL"
        ? allClassIds
        : classFilters;

    // Query variables
    const {
      variables: classTimetableVariables,
    } = getClassTimetablePlannerVariables({
      classIds,
      timetableType,
      academicYearId,
      weekStartDate,
      weekEndDate,
      curriculumProgramId,
      dateRange,
    });

    const {
      variables: teacherTimetableVariables,
    } = getTeacherTimetableVariables({
      weekStartDate,
      weekEndDate,
      academicYearId,
      dateRange,
      selectedStaffId,
      timetableType,
    });

    // Determine which refetch variables to use based on timetable type
    const refetchVariables =
      timetableType === TEACHER
        ? teacherTimetableVariables
        : classTimetableVariables;

    // Determine which query to use based on timetable type
    const query =
      timetableType === TEACHER
        ? getTeacherTimetablePeriodsQuery
        : getClassTimetablePeriodsQuery;

    // Extract necessary data from input for optimistic update
    const { sourceId, destinationId, putAfterItemId } = input;

    // Determine which query to refetch based on timetable type
    const refetchQuery =
      timetableType === TEACHER
        ? getTeacherTimetablePeriodsQuery
        : getClassTimetablePeriodsQuery;

    const refetchQueries = [
      {
        query: refetchQuery,
        variables: refetchVariables,
      },
    ];

    let isOptimistic = true;

    try {
      await client.mutate({
        mutation: moveTimetableSlotContentMutation,
        variables: { input },
        refetchQueries,
        optimisticResponse: {
          __typename: "Mutation",
          platform: {
            moveTimetableSlotContent: true,
            __typename: "PlatformMutations",
          },
        },
        update: cache => {
          moveItem({
            cache,
            query,
            variables: refetchVariables,
            sourceSlotId: sourceId,
            destinationSlotId: destinationId,
            putAfterItemId,
            isOptimistic,
            dispatch,
            showToast,
            id: itemId,
            timetableType,
          });

          isOptimistic = false;
        },
      });
    } catch (error) {
      console.error("Error move timetable slot items:", error);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const duplicateTimetableSlotContent = ({
  input,
  timetableType,
  selectedStaffId,
  showToast = true,
}) => {
  return async (dispatch, getState) => {
    const state = getState();

    const dateRange = _.get(state, "timetablePlanner.dateRange", []);
    const learningCourse = getSelectedLearningCourse(state);
    const academicYearId = getSelectedAcademicYearId(state);
    const curriculumProgramId = getSelectedCurriculumId(state);
    const weekStartDate = _.first(dateRange);
    const weekEndDate = _.last(dateRange);

    const allClassIds = _.get(learningCourse, "classes", []);
    const filters = _.get(state, "timetablePlanner.filters", {});
    const classFilters = _.get(filters, "classes", []);

    const classIds =
      _.isEmpty(classFilters) || classFilters === "ALL"
        ? allClassIds
        : classFilters;

    // Query variables
    const {
      variables: classTimetableVariables,
    } = getClassTimetablePlannerVariables({
      classIds,
      timetableType,
      academicYearId,
      weekStartDate,
      weekEndDate,
      curriculumProgramId,
      dateRange,
    });

    const {
      variables: teacherTimetableVariables,
    } = getTeacherTimetableVariables({
      weekStartDate,
      weekEndDate,
      academicYearId,
      dateRange,
      selectedStaffId,
      timetableType,
    });

    dispatch(setIsLoaderVisible(true));

    try {
      // Determine which query to refetch based on timetable type
      const refetchQuery =
        timetableType === TEACHER
          ? getTeacherTimetablePeriodsQuery
          : getClassTimetablePeriodsQuery;

      // Determine which refetch variables to use based on timetable type
      const refetchVariables =
        timetableType === TEACHER
          ? teacherTimetableVariables
          : classTimetableVariables;

      // Execute mutation with refetch
      await client.mutate({
        mutation: duplicateTimetableSlotContentMutation,
        variables: { input },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: refetchQuery,
            variables: refetchVariables,
          },
        ],
      });

      if (showToast) {
        dispatch(
          getActionToast({
            action: TOAST_ACTION_LABELS.DUPLICATED,
            itemType: _.has(input, "item") ? ITEM_TYPES.ITEM : ITEM_TYPES.ITEMS,
          })
        );
      }
    } catch (error) {
      console.error("Error duplicating timetable slot items:", error);
    } finally {
      dispatch(setIsLoaderVisible(false));
    }
  };
};

// Helper function to add item at correct position in destination items
const addItemAtPosition = ({
  itemToMove,
  destinationItems,
  putAfterItemId,
}) => {
  if (putAfterItemId === null) {
    return [itemToMove, ...destinationItems];
  } else {
    const afterItemIndex = _.findIndex(
      destinationItems,
      item => _.get(item, "id", null) === putAfterItemId
    );

    if (afterItemIndex >= 0) {
      return [
        ...destinationItems.slice(0, afterItemIndex + 1),
        itemToMove,
        ...destinationItems.slice(afterItemIndex + 1),
      ];
    } else {
      return [...destinationItems, itemToMove];
    }
  }
};

// Helper function to handle item movement (both within slot and between slots)
const moveItemBetweenSlots = (
  data,
  sourceSlot,
  destinationSlot,
  putAfterItemId,
  isOptimistic,
  showToast,
  dispatch,
  id,
  sourceSlotId,
  destinationSlotId,
  timetableType
) => {
  const sourceItems = _.cloneDeep(_.get(sourceSlot, "node.items", []));

  let updatedSourceItems;
  let updatedDestinationItems;

  // Handle moving all items when id is not provided
  if (!id) {
    // If source has no items, nothing to move
    if (_.isEmpty(sourceItems)) {
      return data;
    }

    // If source and destination are the same slot, no change needed
    if (sourceSlotId === destinationSlotId) {
      return data;
    }

    // Get existing items from destination slot
    const destinationItems = _.cloneDeep(
      _.get(destinationSlot, "node.items", [])
    );

    // Add all source items at the top of destination
    updatedDestinationItems = [...sourceItems, ...destinationItems];
    // Clear source slot (empty array)
    updatedSourceItems = [];

    if (showToast && !isOptimistic) {
      dispatch(
        getActionToast({
          action: TOAST_ACTION_LABELS.MOVED,
          itemType:
            _.size(sourceItems) > 1 ? ITEM_TYPES.ITEMS : ITEM_TYPES.ITEM,
        })
      );
    }
  } else {
    // Handle moving single item
    const itemToMove = _.find(
      sourceItems,
      slotItem => _.get(slotItem, "id", null) === id
    );

    if (!itemToMove) {
      return data;
    }

    updatedSourceItems = _.filter(
      sourceItems,
      slotItem => _.get(slotItem, "id", null) !== id
    );

    // Prepare destination items - for same slot, use filtered source items
    const destinationItems =
      sourceSlotId === destinationSlotId
        ? updatedSourceItems
        : _.cloneDeep(_.get(destinationSlot, "node.items", []));

    // Check for duplicates only when moving between different slots
    if (sourceSlotId !== destinationSlotId) {
      // Check if item already exists in destination slot (by internal item ID)
      const itemInternalId = _.get(itemToMove, "item.id");
      const itemExistsInDestination = _.find(
        destinationItems,
        item => _.get(item, "item.id") === itemInternalId
      );

      if (itemExistsInDestination) {
        // Item already exists in destination, just remove from source (no duplication)
        const filteredDestinationItems = _.filter(
          destinationItems,
          item => _.get(item, "item.id") !== itemInternalId
        );

        updatedDestinationItems = addItemAtPosition({
          itemToMove: itemExistsInDestination,
          destinationItems: filteredDestinationItems,
          putAfterItemId,
        });

        if (!isOptimistic) {
          dispatch(
            setToastMsg({
              msg: "toastMsgs:same_item_already_exists_in_slot",
              type: "warning",
            })
          );
        }
      } else {
        // Item doesn't exist in destination, add it at the correct position
        updatedDestinationItems = addItemAtPosition({
          itemToMove,
          destinationItems,
          putAfterItemId,
        });

        if (showToast && !isOptimistic) {
          dispatch(
            getActionToast({
              action: TOAST_ACTION_LABELS.MOVED,
              itemType: ITEM_TYPES.ITEM,
            })
          );
        }
      }
    } else {
      // Same slot reordering - always add item at the correct position
      updatedDestinationItems = addItemAtPosition({
        itemToMove,
        destinationItems,
        putAfterItemId,
      });
    }
  }

  // Build update object once at the end
  return timetableType === TEACHER
    ? buildUpdateObjectForTeacher({
        data,
        sourceSlotId,
        destinationSlotId,
        updatedSourceItems,
        updatedDestinationItems,
      })
    : buildUpdateObject({
        data,
        sourceSlot,
        destinationSlot,
        sourceSlotId,
        destinationSlotId,
        updatedSourceItems,
        updatedDestinationItems,
      });
};

// Helper function to build the update object for immutability-helper
const buildUpdateObject = ({
  data,
  sourceSlot,
  destinationSlot,
  sourceSlotId,
  destinationSlotId,
  updatedSourceItems,
  updatedDestinationItems,
}) => {
  // Get course IDs and indices
  const sourceCourseId = _.get(sourceSlot, "node.course.id");
  const destinationCourseId = _.get(destinationSlot, "node.course.id");

  const sourceMnIndex = _.findIndex(data.multiNode, { id: sourceCourseId });
  const destinationMnIndex = _.findIndex(data.multiNode, {
    id: destinationCourseId,
  });

  const sourceEdges = _.get(
    data,
    ["multiNode", sourceMnIndex, "periodsV3", "edges"],
    []
  );
  const destinationEdges = _.get(
    data,
    ["multiNode", destinationMnIndex, "periodsV3", "edges"],
    []
  );

  const sourceEdgeIndex = _.findIndex(
    sourceEdges,
    e => e.node.timetableSlotId === sourceSlotId
  );
  const destinationEdgeIndex = _.findIndex(
    destinationEdges,
    e => e.node.timetableSlotId === destinationSlotId
  );

  if (
    sourceMnIndex === -1 ||
    destinationMnIndex === -1 ||
    sourceEdgeIndex === -1 ||
    destinationEdgeIndex === -1
  ) {
    return data;
  }

  const updateObject = {
    multiNode: {},
  };

  if (sourceSlotId === destinationSlotId) {
    // Same slot - update only once
    updateObject.multiNode[sourceMnIndex] = {
      periodsV3: {
        edges: {
          [sourceEdgeIndex]: {
            node: {
              items: {
                $set: updatedDestinationItems,
              },
            },
          },
        },
      },
    };
  } else {
    // Different slots - update both slots
    // If both slots are in the same course, update both edges in one operation
    if (sourceMnIndex === destinationMnIndex) {
      updateObject.multiNode[sourceMnIndex] = {
        periodsV3: {
          edges: {
            [sourceEdgeIndex]: {
              node: {
                items: {
                  $set: updatedSourceItems,
                },
              },
            },
            [destinationEdgeIndex]: {
              node: {
                items: {
                  $set: updatedDestinationItems,
                },
              },
            },
          },
        },
      };
    } else {
      // Different courses - update separately
      updateObject.multiNode[sourceMnIndex] = {
        periodsV3: {
          edges: {
            [sourceEdgeIndex]: {
              node: {
                items: {
                  $set: updatedSourceItems,
                },
              },
            },
          },
        },
      };
      updateObject.multiNode[destinationMnIndex] = {
        periodsV3: {
          edges: {
            [destinationEdgeIndex]: {
              node: {
                items: {
                  $set: updatedDestinationItems,
                },
              },
            },
          },
        },
      };
    }
  }

  return update(data, updateObject);
};

// Helper function to build the update object for teacher timetables
const buildUpdateObjectForTeacher = ({
  data,
  sourceSlotId,
  destinationSlotId,
  updatedSourceItems,
  updatedDestinationItems,
}) => {
  const teacherPeriods = _.get(data, "node.enrolledPeriodsV2", []);

  const sourceSlotIndex = _.findIndex(
    teacherPeriods,
    period => period.timetableSlotId === sourceSlotId
  );
  const destinationSlotIndex = _.findIndex(
    teacherPeriods,
    period => period.timetableSlotId === destinationSlotId
  );

  if (sourceSlotIndex === -1 || destinationSlotIndex === -1) {
    return data;
  }

  const updateObject = {
    node: {
      enrolledPeriodsV2: {},
    },
  };

  if (sourceSlotId === destinationSlotId) {
    // Same slot - update only once
    updateObject.node.enrolledPeriodsV2[sourceSlotIndex] = {
      items: {
        $set: updatedDestinationItems,
      },
    };
  } else {
    // Different slots - update both slots
    updateObject.node.enrolledPeriodsV2[sourceSlotIndex] = {
      items: {
        $set: updatedSourceItems,
      },
    };
    updateObject.node.enrolledPeriodsV2[destinationSlotIndex] = {
      items: {
        $set: updatedDestinationItems,
      },
    };
  }

  return update(data, updateObject);
};

const moveItem = ({
  cache,
  query,
  variables,
  sourceSlotId,
  destinationSlotId,
  putAfterItemId,
  isOptimistic,
  showToast,
  dispatch,
  id,
  timetableType,
}) => {
  cache.updateQuery(
    {
      query,
      variables,
    },
    data => {
      if (!data) {
        return data;
      }

      let timetableSlots = [];

      // Handle different data structures based on timetable type
      if (timetableType === TEACHER) {
        // Teacher timetable structure: data.node.enrolledPeriodsV2[]
        const teacherPeriods = _.get(data, "node.enrolledPeriodsV2", []);
        if (_.isEmpty(teacherPeriods)) {
          return data;
        }
        // Transform teacher periods to match the expected structure
        timetableSlots = _.map(teacherPeriods, period => ({ node: period }));
      } else {
        // Class timetable structure: data.multiNode[].periodsV3.edges[]
        const timetableData = _.get(data, "multiNode", []);
        if (_.isEmpty(timetableData)) {
          return data;
        }
        timetableSlots = _.flatMap(timetableData, "periodsV3.edges");
      }

      // Find source and destination slots
      const sourceSlot = _.find(
        timetableSlots,
        slot => _.get(slot, "node.timetableSlotId", null) === sourceSlotId
      );

      const destinationSlot = _.find(
        timetableSlots,
        slot => _.get(slot, "node.timetableSlotId", null) === destinationSlotId
      );

      if (!sourceSlot || !destinationSlot) {
        return data;
      }

      // Use unified update strategy for both timetable types
      return moveItemBetweenSlots(
        data,
        sourceSlot,
        destinationSlot,
        putAfterItemId,
        isOptimistic,
        showToast,
        dispatch,
        id,
        sourceSlotId,
        destinationSlotId,
        timetableType
      );
    }
  );
};

// Reorder items within the same timetable slot
export const reorderTimetableSlotContent = args => async (
  dispatch,
  getState
) => {
  const {
    id,
    timetableSlotId,
    putAfterItemId,
    timetableType,
    selectedStaffId = "",
  } = args;
  const state = getState();
  const dateRange = _.get(state, "timetablePlanner.dateRange", []);
  // Ensure dates are properly formatted for GraphQL queries
  const weekStartDate = _.first(dateRange);
  const weekEndDate = _.last(dateRange);
  const academicYearId = getSelectedAcademicYearId(state);
  const curriculumId = getSelectedCurriculumId(state);
  const learningCourse = getSelectedLearningCourse(state);

  // Get classIds like other functions do
  const allClassIds = _.get(learningCourse, "classes", []);
  const filters = _.get(state, "timetablePlanner.filters", {});
  const classFilters = _.get(filters, "classes", []);
  const classIds =
    _.isEmpty(classFilters) || classFilters === "ALL"
      ? allClassIds
      : classFilters;

  try {
    // Determine which refetch variables to use based on timetable type
    const {
      variables: classTimetableVariables,
    } = getClassTimetablePlannerVariables({
      classIds,
      timetableType,
      academicYearId,
      weekStartDate,
      weekEndDate,
      curriculumProgramId: curriculumId,
      dateRange,
    });

    const {
      variables: teacherTimetableVariables,
    } = getTeacherTimetableVariables({
      weekStartDate,
      weekEndDate,
      academicYearId,
      dateRange,
      selectedStaffId,
      timetableType,
    });

    // Determine which refetch variables to use based on timetable type
    const refetchVariables =
      timetableType === TEACHER
        ? teacherTimetableVariables
        : classTimetableVariables;

    const query =
      timetableType === TEACHER
        ? getTeacherTimetablePeriodsQuery
        : getClassTimetablePeriodsQuery;

    const input = {
      id,
      timetableSlotId,
      putAfterItemId,
      academicYearId,
    };

    // Determine which query to refetch based on timetable type
    const refetchQuery =
      timetableType === TEACHER
        ? getTeacherTimetablePeriodsQuery
        : getClassTimetablePeriodsQuery;

    let isOptimistic = true;

    await client.mutate({
      mutation: reorderTimetableSlotContentMutation,
      variables: { input },
      refetchQueries: [
        {
          query: refetchQuery,
          variables: refetchVariables,
        },
      ],
      optimisticResponse: {
        __typename: "Mutation",
        platform: {
          reorderTimetableSlotContent: true,
          __typename: "PlatformMutations",
        },
      },
      update: cache => {
        moveItem({
          cache,
          query,
          variables: refetchVariables,
          sourceSlotId: timetableSlotId,
          destinationSlotId: timetableSlotId,
          putAfterItemId,
          isOptimistic,
          dispatch,
          id,
          timetableType,
        });

        isOptimistic = false;
      },
    });

    return { success: true };
  } catch (error) {
    console.error("Error reordering timetable slot content:", error);
    throw error;
  }
};

export const clearTimetableSlotContent = ({
  input,
  timetableType,
  selectedStaffId,
  showToast = true,
}) => {
  return async (dispatch, getState) => {
    const state = getState();

    const dateRange = _.get(state, "timetablePlanner.dateRange", []);
    const learningCourse = getSelectedLearningCourse(state);
    const academicYearId = getSelectedAcademicYearId(state);
    const curriculumProgramId = getSelectedCurriculumId(state);
    const weekStartDate = _.first(dateRange);
    const weekEndDate = _.last(dateRange);

    const allClassIds = _.get(learningCourse, "classes", []);
    const filters = _.get(state, "timetablePlanner.filters", {});
    const classFilters = _.get(filters, "classes", []);

    const classIds =
      _.isEmpty(classFilters) || classFilters === "ALL"
        ? allClassIds
        : classFilters;

    // Query variables
    const {
      variables: classTimetableVariables,
    } = getClassTimetablePlannerVariables({
      classIds,
      timetableType,
      academicYearId,
      weekStartDate,
      weekEndDate,
      curriculumProgramId,
      dateRange,
    });

    const {
      variables: teacherTimetableVariables,
    } = getTeacherTimetableVariables({
      weekStartDate,
      weekEndDate,
      academicYearId,
      dateRange,
      selectedStaffId,
      timetableType,
    });

    dispatch(setIsLoaderVisible(true));

    try {
      // Determine which query to refetch based on timetable type
      const refetchQuery =
        timetableType === TEACHER
          ? getTeacherTimetablePeriodsQuery
          : getClassTimetablePeriodsQuery;

      // Determine which refetch variables to use based on timetable type
      const refetchVariables =
        timetableType === TEACHER
          ? teacherTimetableVariables
          : classTimetableVariables;

      // Execute mutation with refetch
      await client.mutate({
        mutation: clearTimetableSlotContentMutation,
        variables: { input },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: refetchQuery,
            variables: refetchVariables,
          },
        ],
      });

      if (showToast) {
        dispatch(
          getActionToast({
            action: TOAST_ACTION_LABELS.CLEARED,
            itemType: ITEM_TYPES.ITEMS,
          })
        );
      }
    } catch (error) {
      console.error("Error clearing timetable slot items:", error);
    } finally {
      dispatch(setIsLoaderVisible(false));
    }
  };
};
export const getTimetablePlannerDownloadUrl = params => {
  return async dispatch => {
    try {
      const result = await client.mutate({
        mutation: getTimetablePlannerDownloadUrlMutation,
        variables: params,
      });

      const { isSuccess } = _.get(
        result,
        "data.platform.timetablePlannerDownloadUrl",
        {}
      );

      if (isSuccess) {
        // Long running task created - show success toast
        dispatch(
          setToastMsg({
            msg: "toastMsgs:timetable_download_success_msg",
            type: "success",
          })
        );
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    } catch (error) {
      if (error.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

// Initial State
const initialState = {
  dateRange: [],
  filters: {},
  displaySettings: {},
  isLoaderVisible: false,
  addNoteModalData: {},
  addLinkModalData: {},
  courseFlowModalData: {},
  classAssignmentModalData: {},
  assessmentImportModalData: {},
  activeSlot: null,
  worksheetModalData: {},
  changeTaskTypeModalData: {},
  selectSlotItemModalData: {},
  shareContentModalData: {},
  assignmentModalData: {},
};

// Reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_DATE_RANGE: {
      const { data } = action;
      const { dateRange } = data;
      return update(state, {
        dateRange: { $set: dateRange },
      });
    }
    case UPDATE_FILTERS: {
      const params = action.data;
      _.map(Object.keys(params), key => {
        state = update(state, {
          filters: { [key]: { $set: params[key] } },
        });
      });

      return state;
    }
    case SET_IS_LOADER_VISIBLE: {
      const { data } = action;
      return update(state, {
        isLoaderVisible: { $set: data },
      });
    }
    case UPDATE_DISPLAY_SETTINGS: {
      const { data } = action;
      return update(state, {
        displaySettings: { $set: data },
      });
    }
    case SET_ADD_NOTE_MODAL_DATA: {
      const { data } = action;
      return update(state, {
        addNoteModalData: { $set: data },
      });
    }
    case SET_ADD_LINK_MODAL_DATA: {
      const { data } = action;
      return update(state, {
        addLinkModalData: { $set: data },
      });
    }
    case SET_COURSE_FLOW_MODAL_DATA: {
      const { data } = action;
      return update(state, {
        courseFlowModalData: { $set: data },
      });
    }
    case SET_CLASS_ASSIGNMENT_MODAL_DATA: {
      const { data } = action;
      return update(state, {
        classAssignmentModalData: { $set: data },
      });
    }
    case SET_ASSESSMENT_IMPORT_MODAL_DATA: {
      const { data } = action;
      return update(state, {
        assessmentImportModalData: { $set: data },
      });
    }
    case SET_WORKSHEET_MODAL_DATA: {
      const { data } = action;
      return update(state, {
        worksheetModalData: { $set: data },
      });
    }
    case SET_CHANGE_TASK_TYPE_MODAL_DATA: {
      const { data } = action;
      return update(state, {
        changeTaskTypeModalData: { $set: data },
      });
    }
    case SET_ACTIVE_SLOT_ID: {
      const { data } = action;
      return update(state, {
        activeSlot: { $set: data },
      });
    }
    case SET_SHARE_CONTENT_MODAL_DATA: {
      const { data } = action;
      return update(state, {
        shareContentModalData: { $set: data },
      });
    }
    case SET_ASSESSMENT_MODAL_DATA: {
      const { data } = action;
      return update(state, {
        assignmentModalData: { $set: data },
      });
    }
    case SET_SELECT_ITEM_SLOT_MODAL: {
      const { data } = action;
      return update(state, {
        selectSlotItemModalData: { $set: data },
      });
    }
    case RESET_REDUX_STATE: {
      return initialState;
    }
    default:
      return state;
  }
}
